import React, { useState } from 'react';
import { PayrollAuthProvider, usePayrollAuth } from './PayrollAuth';
import PayrollLogin from './PayrollLogin';
import PayrollEmployees from '../pages/payroll/Employees';
import Shifts from '../pages/payroll/Shifts';
import Adjustments from '../pages/payroll/Adjustments';
import Payroll from '../pages/payroll/Payroll';
import Stats from '../pages/payroll/Stats';
import Users from './Users';
import Logs from '../pages/payroll/Logs';
import Accountant from '../pages/payroll/Accountant';
import Database from '../pages/payroll/Database';
import Hotels from '../pages/payroll/Hotels';
import Advances from '../pages/payroll/Advances';
import '../pages/payroll/PayrollTable.css';

const TABS_BY_ROLE = {
  superadmin:   ['shifts', 'advances', 'adjustments', 'payroll', 'employees', 'accountant', 'hotels', 'database', 'stats', 'users', 'logs'],
  dept_head:    ['shifts', 'advances', 'adjustments', 'payroll', 'stats'],
  hotel_manager:['shifts', 'advances', 'adjustments', 'payroll', 'employees'],
  accountant:   ['advances', 'payroll', 'stats'],
};

const TAB_LABELS = {
  advances: 'Авансы',
  users: 'Пользователи',
  accountant: 'Бухгалтерия',
  hotels:    'Отели',
  database:   'База',
  logs:  'Логи',
  employees:   'Сотрудники',
  shifts:      'Табель',
  adjustments: 'Штрафы и плюсы',
  payroll:     'Ведомость',
  stats:       'Статистика',
};

function PayrollPortal() {
  const { user, logout } = usePayrollAuth();
  const [tab, setTab] = useState('shifts');

  const tabs = TABS_BY_ROLE[user?.role] || ['shifts', 'adjustments', 'payroll'];

  const renderTab = () => {
    switch(tab) {
      case 'employees':   return <PayrollEmployees />;
      case 'shifts':      return <Shifts />;
      case 'adjustments': return <Adjustments />;
      case 'payroll':     return <Payroll />;
      case 'stats':       return <Stats />;
      case 'advances':    return <Advances />;
      case 'users':       return <Users />;
      case 'accountant':  return <Accountant />;
      case 'hotels':      return <Hotels />;
      case 'database':    return <Database />;
      case 'logs':        return <Logs />;
      default:            return <Shifts />;
    }
  };

  return (
    <div style={{ minHeight:'100vh', background:'#f9fafb' }}>
      {/* Хедер */}
      <div style={{ background:'#111827', padding:'0 24px', display:'flex', alignItems:'center', justifyContent:'space-between', height:56 }}>
        <div style={{ display:'flex', alignItems:'center', gap:12 }}>
          <span style={{ color:'#00d2b4', fontWeight:700, fontSize:16, letterSpacing:'0.1em' }}>THOTH AI</span>
          <span style={{ color:'#374151', fontSize:14 }}>|</span>
          <span style={{ color:'#9ca3af', fontSize:14 }}>Ведомости</span>
        </div>
        <div style={{ display:'flex', alignItems:'center', gap:16 }}>
          <span style={{ color:'#9ca3af', fontSize:13 }}>{user?.name}</span>
          <button
            onClick={logout}
            style={{ background:'none', border:'1px solid #374151', color:'#9ca3af', padding:'6px 14px', borderRadius:8, fontSize:13, cursor:'pointer' }}
          >
            Выйти
          </button>
        </div>
      </div>

      {/* Табы */}
      <div style={{ background:'#fff', borderBottom:'1px solid #e5e7eb', padding:'0 24px', display:'flex', gap:4 }}>
        {tabs.map(t => (
          <button
            key={t}
            onClick={() => setTab(t)}
            style={{
              padding:'12px 20px',
              border:'none',
              borderBottom: tab === t ? '2px solid #111827' : '2px solid transparent',
              background:'none',
              fontSize:14,
              fontWeight: tab === t ? 600 : 400,
              color: tab === t ? '#111827' : '#6b7280',
              cursor:'pointer',
              transition:'all 0.15s',
            }}
          >
            {TAB_LABELS[t]}
          </button>
        ))}
      </div>

      {/* Контент */}
      <div style={{ padding:24 }}>
        {renderTab()}
      </div>
    </div>
  );
}

function PayrollAppInner() {
  const { user, loading } = usePayrollAuth();

  if (loading) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', background:'#0a0f0e', color:'#00d2b4', fontSize:14, letterSpacing:'0.15em' }}>
      ЗАГРУЗКА...
    </div>
  );

  return user ? <PayrollPortal /> : <PayrollLogin />;
}

export default function PayrollApp() {
  return (
    <PayrollAuthProvider>
      <PayrollAppInner />
    </PayrollAuthProvider>
  );
}
